<template>
  <px-custom-dialog transition="fadet"
                    width="400"
                    v-model="dialog">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
      </slot>
    </template>
    <template v-slot:title>
      Filtros avançados
    </template>
    <template>
      <template>
        <v-row>
          <v-col cols="12">
            <px-input-money
              label="Valor de mercadoria maior que"
              class="required"
              ref="valorMercadoriaLocal"
              v-model="valorMercadoriaLocal"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <px-input-number label="Peso maior que (kg)"
                             v-model="pesoLocal"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <px-autocomplete-municipio-multiple label="Municípios de coleta"
                                                v-model="municipiosColetaLocal"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <px-autocomplete-municipio-multiple label="Municípios de entrega"
                                                v-model="municipiosEntregaLocal"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <px-autocomplete-estado-multiple label="Estados de coleta"
                                             v-model="estadosColetaLocal"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <px-autocomplete-estado-multiple label="Estados de entrega"
                                             v-model="estadosEntregaLocal"/>
          </v-col>
        </v-row>
      </template>
    </template>
    <template v-slot:actions>
      <v-btn color="primary" @click="applyFilters">
        Aplicar filtros
      </v-btn>
      <v-btn @click="close">
        Fechar
      </v-btn>
    </template>
  </px-custom-dialog>

</template>

<script>
import { isEmpty } from 'lodash';

export default {
  data() {
    return {
      dialog: false,
      valorMercadoriaLocal: 0,
      pesoLocal: null,
      municipiosColetaLocal: [],
      municipiosEntregaLocal: [],
      estadosColetaLocal: [],
      estadosEntregaLocal: [],
    };
  },
  computed: {
    valorMercadoria: {
      get() {
        return this.$store.getters['painelCotacao/valorMercadoria'];
      },
      set(valorMercadoria) {
        this.$store.dispatch('painelCotacao/valorMercadoria', valorMercadoria);
      },
    },
    municipiosColeta: {
      get() {
        return this.$store.getters['painelCotacao/municipiosColeta'];
      },
      set(municipiosColeta) {
        this.$store.dispatch('painelCotacao/municipiosColeta', municipiosColeta);
      },
    },
    municipiosEntrega: {
      get() {
        return this.$store.getters['painelCotacao/municipiosEntrega'];
      },
      set(municipiosEntrega) {
        this.$store.dispatch('painelCotacao/municipiosEntrega', municipiosEntrega);
      },
    },
    estadosColeta: {
      get() {
        return this.$store.getters['painelCotacao/estadosColeta'];
      },
      set(estadosColeta) {
        this.$store.dispatch('painelCotacao/estadosColeta', estadosColeta);
      },
    },
    estadosEntrega: {
      get() {
        return this.$store.getters['painelCotacao/estadosEntrega'];
      },
      set(estadosEntrega) {
        this.$store.dispatch('painelCotacao/estadosEntrega', estadosEntrega);
      },
    },
    peso: {
      get() {
        return this.$store.getters['painelCotacao/peso'];
      },
      set(peso) {
        this.$store.dispatch('painelCotacao/peso', peso);
      },
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    setupInitialState() {
      if (this.valorMercadoria && this.valorMercadoria > 0) {
        this.valorMercadoria = this.valorMercadoria.toFixed(2);
        this.valorMercadoriaLocal = this.valorMercadoria;
      } else {
        this.valorMercadoriaLocal = 0;
        if (this.$refs.valorMercadoriaLocal) {
          this.$refs.valorMercadoriaLocal.$el.getElementsByTagName('input')[0].value = 0;
        }
      }
      if (!isEmpty(this.municipiosColeta)) {
        this.municipiosColetaLocal = this.municipiosColeta;
      } else {
        this.municipiosColetaLocal = [];
      }
      if (!isEmpty(this.municipiosEntrega)) {
        this.municipiosEntregaLocal = this.municipiosEntrega;
      } else {
        this.municipiosEntregaLocal = [];
      }
      if (!isEmpty(this.estadosColeta)) {
        this.estadosColetaLocal = this.estadosColeta;
      } else {
        this.estadosColetaLocal = [];
      }
      if (!isEmpty(this.estadosEntrega)) {
        this.estadosEntregaLocal = this.estadosEntrega;
      } else {
        this.estadosEntregaLocal = [];
      }
      if (this.peso && this.peso > 0) {
        this.pesoLocal = this.peso;
      } else {
        this.pesoLocal = null;
      }
    },
    applyFilters() {
      this.valorMercadoria = this.valorMercadoriaLocal;
      this.peso = this.pesoLocal;
      this.municipiosColeta = this.municipiosColetaLocal;
      this.municipiosEntrega = this.municipiosEntregaLocal;
      this.estadosColeta = this.estadosColetaLocal;
      this.estadosEntrega = this.estadosEntregaLocal;
      this.$emit('change');
      this.close();
    },
  },
  watch: {
    dialog(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (!newValue) {
        return;
      }
      this.setupInitialState();
    },
  },
  created() {
    this.setupInitialState();
  },
};
</script>
